<template>
  <div class="title-subtile-holder">
    <h2 class="section-title  ">{{ title }}</h2>
    <div class="svg-border ">
      <svg
        width="515"
        height="25"
        viewBox="0 0 275 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="7" width="120" height="1" fill="#CCCCCC"></rect>
        <rect x="155" y="7" width="120" height="1" fill="#CCCCCC"></rect>
        <path
          d="M144.443 14.6458C144.207 14.8818 143.897 15 143.588 15C143.278 15 142.968 14.8818 142.732 14.6454L137.874 9.78689C137.517 9.43023 137.43 8.90654 137.612 8.46798L136.617 7.47264L135.242 8.84723C135.517 9.2862 135.458 9.8809 135.066 10.2714C134.614 10.7245 133.888 10.7342 133.448 10.2936L130.324 7.17126C129.883 6.73028 129.893 6.00566 130.347 5.55298C130.738 5.16122 131.332 5.10231 131.771 5.37788L135.378 1.77014C135.102 1.33158 135.161 0.737682 135.553 0.346326C136.006 -0.10676 136.73 -0.116443 137.171 0.324136L140.295 3.44732C140.736 3.8879 140.726 4.61251 140.272 5.0656C139.88 5.45736 139.287 5.51586 138.849 5.2407L137.472 6.6169L138.59 7.73449C138.945 7.69334 139.314 7.80348 139.586 8.07622L144.444 12.9347C144.916 13.4071 144.916 14.1729 144.443 14.6458Z"
          fill="var(--primary-color)"
        ></path>
      </svg>
    </div>
    <div class="section-subtitle text-center">
      {{ subtitle }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
    },
  },
};
</script>

<style scoped="scoped">
.title-subtile-holder .section-title {
  margin-top: 0;
}
.section-title {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 34px;
  line-height: 1.2;
  margin-bottom: 0;
}
.title-subtile-holder .svg-border {
  width: 100%;
  height: 23px;
  text-align: center;
  margin: 5px 0 10px;
}
.title-subtile-holder {
  margin-bottom: 25px;
}
@media (max-width: 767.98px) {
  .svg-border{
    display:flex;
    justify-content: center;
  }
}

</style>
